import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from "react";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
const SectionTitle = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mb-4 text-left text-lg font-semibold text-neutral-800 sm:text-xl", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <h2 className={t1}>{children}</h2>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const FieldRow = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex w-full flex-col gap-4 sm:flex-row sm:gap-4">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function PersonalDetails(props) {
  const $ = _c(24);
  const t = useTranslations("home.signUp.form");
  let t0;
  if ($[0] !== t) {
    t0 = t("personalDetails");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SectionTitle>{t0}</SectionTitle>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.firstName) {
    t2 = <div className="flex-1">{props.firstName}</div>;
    $[4] = props.firstName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.lastName) {
    t3 = <div className="flex-1">{props.lastName}</div>;
    $[6] = props.lastName;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <FieldRow>{t2}{t3}</FieldRow>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props.contactNumber) {
    t5 = <div className="flex-1">{props.contactNumber}</div>;
    $[11] = props.contactNumber;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props.email) {
    t6 = <div className="flex-1">{props.email}</div>;
    $[13] = props.email;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <FieldRow>{t5}{t6}</FieldRow>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t7) {
    t8 = <div className="flex flex-col gap-4">{t4}{t7}</div>;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t1 || $[22] !== t8) {
    t9 = <section>{t1}{t8}</section>;
    $[21] = t1;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
function BusinessDetails(props) {
  const $ = _c(30);
  const t = useTranslations("home.signUp.form");
  let t0;
  if ($[0] !== t) {
    t0 = t("businessDetails");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SectionTitle>{t0}</SectionTitle>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.businessName) {
    t2 = <div className="flex-1">{props.businessName}</div>;
    $[4] = props.businessName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.website) {
    t3 = <div className="flex-1">{props.website}</div>;
    $[6] = props.website;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <FieldRow>{t2}{t3}</FieldRow>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props.street) {
    t5 = <FieldRow><div className="flex-1">{props.street}</div></FieldRow>;
    $[11] = props.street;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props.city) {
    t6 = <div className="flex-1">{props.city}</div>;
    $[13] = props.city;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== props.zipCode) {
    t7 = <div className="flex-1">{props.zipCode}</div>;
    $[15] = props.zipCode;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== props.country) {
    t8 = <div className="flex-1">{props.country}</div>;
    $[17] = props.country;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <FieldRow>{t6}{t7}{t8}</FieldRow>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t4 || $[24] !== t5 || $[25] !== t9) {
    t10 = <div className="flex flex-col gap-4">{t4}{t5}{t9}</div>;
    $[23] = t4;
    $[24] = t5;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t1 || $[28] !== t10) {
    t11 = <section>{t1}{t10}</section>;
    $[27] = t1;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
export const FormSection = {
  PersonalDetails,
  BusinessDetails
};